export default {
	craftsmanTasks: {
		create: 'Create craftsman task',
		subject_type: 'Type',
		craftsman: 'Craftsman',
		craftsmanTaskType: 'Craftsman Task Type',
		scheduling: 'Scheduling',
		process: 'Process',
		building: {
			name: '@:entity.building.name',
		},
		unit: {
			name: '@:entity.unit.name',
		},
		team: {
			last_name: '@:entity.team.name',
		},
		assignedOn: 'Assigned on',
		completed: 'Completed',
		estimated_price: 'Estimated Price',
		status_text: 'Information about the current status',
		contact_persons: 'Contact Persons',
		isUpdated: 'is updated',
		total_amount: '@:component.invoice.total_amount',
	},
}
